var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#F5F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 47C31.767 47 27 36.5135 27 30.5C27 26.3645 30.3645 23 34.5 23C38.6355 23 42 26.3645 42 30.5C42 36.5135 37.233 47 34.5 47ZM34.5 20C28.701 20 24 24.701 24 30.5C24 36.299 28.701 50 34.5 50C40.299 50 45 36.299 45 30.5C45 24.701 40.299 20 34.5 20ZM34.5 32.9525C33.6735 32.9525 33 32.2805 33 31.4525C33 30.626 33.6735 29.9525 34.5 29.9525C35.3265 29.9525 36 30.626 36 31.4525C36 32.2805 35.3265 32.9525 34.5 32.9525ZM34.5 26.9525C32.0145 26.9525 30 28.9685 30 31.4525C30 33.938 32.0145 35.9525 34.5 35.9525C36.9855 35.9525 39 33.938 39 31.4525C39 28.9685 36.9855 26.9525 34.5 26.9525Z",
    fill: "#304659"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.76344975a7a32d4f5ad5338e9531e759.svg";
export { ForwardRef as ReactComponent };